import React from 'react';
import LocalSearchDropdown from './LocalSearchDropdown';

const PassengersInClaimDropdown = (props) => (
  <LocalSearchDropdown
    {...props}
    mapText={
      (claimPassengerTicket) => {
        return claimPassengerTicket.passengerTicket.passengerFirstName + ' ' +
        claimPassengerTicket.passengerTicket.passengerLastName}
    }
    mapToSearchString={
      (claimPassengerTicket) => {
        const passengerTicket = claimPassengerTicket.passengerTicket
        return passengerTicket.passengerFirstName + ' ' + passengerTicket.passengerLastName
      }
    }
    headers={['Search Passengers in claim', 'Filter by tag']}
    />
)

export default PassengersInClaimDropdown;



// WEBPACK FOOTER //
// ./src/component/PassengersInClaimDropdown.js